import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { ModalFooter, ModalFormSection } from 'components/common/modals';
import { FieldV2 } from 'components/common/form-controls';
import { ButtonV2 } from 'components/common/ui';
import validationSchema from './addVehiclesValidationSchema';

import styles from './procurementOrderContent.style';

const AddVehiclesForm = ({ loading, onCancel, onSubmit }) => {
  const resolver = yupResolver(validationSchema);

  const methods = useForm({ resolver });

  return (
    <FormProvider {...methods}>
      <form
        id="add-sku-vehicles-form"
        onSubmit={(e) => {
          e.stopPropagation();
          e.preventDefault();

          methods.handleSubmit(() => onSubmit(methods.getValues()))(e);
        }}
      >
        <ModalFormSection>
          <Box sx={styles.row}>
            <FieldV2
              label="Quantity"
              name="quantity"
              type="number"
              control={methods.control}
              min={1}
              isRequired
            />
          </Box>
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            type="submit"
            disabled={
              methods.formState.isSubmitting || !methods.formState.isDirty
            }
            loading={loading}
          >
            Add
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default AddVehiclesForm;
